grecaptcha.ready(function () {
    // console.log('reCAPTCHA is ready');

    // Function to get token for a specific form
    function getToken(formId) {
        // console.log('Getting token for form:', formId);
        grecaptcha.execute(MyAjax.recaptcha_site_key, {action: 'submit'})
            .then(function (token) {
                // console.log('Token received for form:', formId);
                var inputElement = document.getElementById(formId + '_recaptchaResponse');
                if (inputElement) {
                    inputElement.value = token;
                    // console.log('Token set for form:', formId);
                } else {
                    // console.error('recaptchaResponse input not found for form:', formId);
                }
            })
            .catch(function (error) {
                // console.error('Error getting token for form:', formId, error);
            });
    }

    // Get tokens for both forms
    getToken('contact');
    getToken('newsletter');

    // Refresh tokens every 2 minutes
    setInterval(function () {
        // console.log('Refreshing tokens');
        getToken('contact');
        getToken('newsletter');
    }, 120000);
});

// Check token values after a short delay
setTimeout(function () {
    var contactToken = document.getElementById('contact_recaptchaResponse');
    var newsletterToken = document.getElementById('newsletter_recaptchaResponse');
    // console.log('Contact form token value:', contactToken ? contactToken.value : 'Element not found');
    // console.log('Newsletter form token value:', newsletterToken ? newsletterToken.value : 'Element not found');
}, 5000);